module.exports = __webpack_public_path__ + "img/flags/GU.192f08e.png";